import React from 'react'
import AdminContentLayout from '../../components/layout/AdminContentLayout'
import AdminLayout from '../../components/layout/AdminLayout'
import StudentInfoBox from '../../components/manager/StudentInfoBox'

const StudentInfo = () => {
  return (
    <AdminLayout>
      <AdminContentLayout children={<StudentInfoBox />} />
    </AdminLayout>
  )
}

export default StudentInfo
